import { Lottie, ThemeConfig } from "@swiggy-private/cart-types";
import React from "react";

export interface CartHeaderLottieState {
    cartType: string;
    hasLottie: boolean;
    showFinalState: boolean;
    hideTheme: boolean;
    showAnimation: boolean;
    themeChange: boolean;
    isStatusSuccess: boolean;
    startAnimation: boolean;
    lottieArray: Lottie[];
    themeConfig?: ThemeConfig;
}

export interface CartHeaderLottieContextValue {
    cartHeaderLottieState: CartHeaderLottieState;
    setCartHeaderLottieState: React.Dispatch<React.SetStateAction<CartHeaderLottieState>>;
}

export const INITIAL_CART_HEADER_LOTTIE_CONTEXT_VALUE: CartHeaderLottieContextValue = {
    cartHeaderLottieState: {
        cartType: "",
        hasLottie: false,
        showFinalState: false,
        hideTheme: false,
        showAnimation: false,
        themeChange: false,
        isStatusSuccess: false,
        startAnimation: false,
        lottieArray: [],
        themeConfig: undefined,
    },
    setCartHeaderLottieState: () => void 0,
};

export const CartHeaderLottieContext = React.createContext<CartHeaderLottieContextValue>(
    INITIAL_CART_HEADER_LOTTIE_CONTEXT_VALUE,
);

if (__DEV__) {
    CartHeaderLottieContext.displayName = "CartHeaderLottieContext";
}
